var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.0013 13.8333C3.63464 13.8333 3.32064 13.7027 3.0593 13.4413C2.79797 13.18 2.66753 12.8662 2.66797 12.5V10.5H4.0013V12.5H12.0013V10.5H13.3346V12.5C13.3346 12.8667 13.204 13.1807 12.9426 13.442C12.6813 13.7033 12.3675 13.8338 12.0013 13.8333H4.0013ZM8.0013 3.16667L11.3346 6.50001L10.4013 7.46667L8.66797 5.73334V11.1667H7.33464V5.73334L5.6013 7.46667L4.66797 6.50001L8.0013 3.16667Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.26bc0f4cb296f5103bdf50c40ad40411.svg";
export { ForwardRef as ReactComponent };